const notifications = {
  error: {
    gpsBusinessLogic: {
      newInspection:
        "No es posible crear una nueva inspeccíon. Distancia del Equipo en Km:",
      permission: "Permiso denegado. Chequee permisos de usuario.",
      position: "Información de ubicación no disponible.",
      timeout: "Solicitud de ubicación sin respuesta.",
      unknown: "Error desconocido."
    },
    userProfile: {}
  },
  success: {
    inspectionProfile: {
      multimediaUpload: "El archivo fue cargado"
    }
  },
  messages: {
    updateAvailable: "Nueva version disponible!",
    getOurApp:
      "Descargue nuestra App. No le ocupará espacio en su dispositivo y funciona sin conexión a internet!",
    getOurAppIphone1: "Descargue nuestra App en su iPhone: Presione",
    getOurAppIphone2: "y luego Agréguela a su Pantalla de Inicio"
  },
  buttons: {
    dismiss: "Ignorar",
    install: "Instalar"
  }
};
export default notifications;
